{
    "title": "Vêtir",
    "description": "Vêtir is a revolutionary AI-powered smart shopping, digital styling and closet management omnichannel platform.",
    "keywords": "Vêtir, AI-powered smart shopping, digital styling, closet management, omnichannel platform, luxury shopping, technology meet",

    "pages": {
        "home ": {
            "title": "Vêtir, Designer Clothes, Shoes, Bags & Accessories for Women | Vetir",
            "description": "Explore the newest in luxury designer collections for women's fashion, accessories, and beauty.",
            "keywords": "Vêtir, Vetir app, Vetir, Designer Clothes, Shoes, Bags & Accessories for Women | Vêtir"
        },
        "home Women": {
            "title": "Vêtir, Designer Clothes, Shoes, Bags & Accessories for Women | Vêtir",
            "description": "Explore the newest in luxury designer collections for women's fashion, accessories, and beauty.",
            "keywords": "Vêtir, Designer Clothes, Shoes, Bags & Accessories for Women | Vêtir"
        },
        "home Men": {
            "title": "Designer Clothes, Shoes, Bags & Accessories for Men | Vêtir",
            "description": "Find the best of men's designer clothing, luxury accessories and wellness.",
            "keywords": "Designer Clothes, Shoes, Bags & Accessories for Men | Vêtir"
        },

        "clothing Women": {
            "title": "Women's Clothing | Vêtir | Where Luxury Shopping & Technology Meet",
            "description": "Shop the best of women's dresses, apparel, shoes, handbags, jewelry and accessories",
            "keywords": "Women's Clothing, Dresses, Apparel, Shoes, Handbags, Jewelry & Accessories | Vêtir"
        },

        "New Arrivals": {
            "title": "Discover the Newest Arrivals in Fashion | Vêtir",
            "description": "Be the first to explore the latest trends and essential pieces in our new arrivals collection, featuring cutting-edge fashion that sets the style.",
            "keywords": "Discover the Newest Arrivals in Fashion, Luxury Shopping, Technology Integration, Fashion Insights"
        },
        "edit": {
            "title": "Our Style Guide to Latest Fashion News, Trends & Stories | Vêtir",
            "description": "Explore the latest fashion news, trends, and stories from the world of luxury and technology.",
            "keywords": "Our Style Guide to Latest Fashion News, Trends & Stories, Fashion News, Trends, Stories, Luxury Shopping, Technology Integration, Fashion Insights"
        },
        "designers Women": {
            "title": "Women’s Fashion Designers | Fashion and Designer | Vêtir",
            "description": "Explore the latest fashion trends and designers from around the world.",
            "keywords": "Women’s Fashion Designers, Fashion, Trends, Luxury Shopping, Technology Integration, Fashion Insights"
        },
        "designers Men": {
            "title": "Men’s Fashion Designers | Fashion and Designer | Vêtir",
            "description": "Explore the latest fashion trends and designers from around the world.",
            "keywords": "Men’s Fashion Designers, Fashion, Trends, Luxury Shopping, Technology Integration, Fashion Insights"
        },
        "video": {
            "title": "Shop & Watch | Luxury Fashion, Beauty & Lifestyle | Vêtir",
            "description": "Explore the latest luxury fashion, beauty, and lifestyle products from the world's leading brands.",
            "keywords": "Shop & Watch, Luxury Fashion, Beauty & Lifestyle, Vêtir, Luxury Shopping, Technology Integration, Fashion Insights"
        },
        "trending": {
            "title": "Currently Trending Designers, Fashion and More | Vêtir",
            "description": "Discover the latest fashion trends and designers from around the world.",
            "keywords": "Currently Trending Designers, Fashion, Trends, Luxury Shopping, Technology Integration, Fashion Insights"
        },
        "stories-details": {
            "title": "The Edit | Vêtir",
            "description": "Explore the latest fashion news, trends, and stories from the world of luxury and technology.",
            "keywords": "The Edit, Fashion News, Trends, Stories, Luxury Shopping, Technology Integration, Fashion Insights"
        },

        "ai-stylist": {
            "title": "Fashion Styling and Outfitting | AI Stylist | Vêtir",
            "description": "Experience personalized fashion styling and outfit recommendations with our AI stylist, designed to enhance your wardrobe and style.",
            "keywords": "Fashion Styling and Outfitting, AI Stylist, Personalized Styling, Wardrobe Enhancement, Fashion Recommendations, Luxury Shopping, Technology Integration"
        },
        "white-glove-digitization": {
            "title": "Concierge Shopping & Styling | Vêtir",
            "description": "Experience personalized shopping and styling services with our expert concierge team, dedicated to finding the perfect items to enhance your wardrobe.",
            "keywords": "Concierge Shopping & Styling, Personalized Shopping, Styling Services, Luxury Shopping, Fashion Styling, Wardrobe Enhancement, Expert Guidance, Luxury Brands"
        },
        "affiliate": {
            "title": "Join the Vêtir Affiliate Network | Vêtir",
            "description": "At Vêtir, we are revolutionizing social commerce. We partner with luxury-minded fashion creators who align with our ethos. Join our affiliate network to monetize your influence—with our in-app social integration, it’s easy to share your digital closet and curated style with your community.",
            "keywords": "Affiliate Program, Commission Earnings, Affiliate Marketing, Vêtir, Luxury Shopping, Technology Integration, Fashion Insights"
        },

        "privacy-policy": {
            "title": "Vêtir (Privacy Policy) | Vêtir | Luxury Shopping & Technology Meet",
            "description": "Explore our privacy policy, which outlines how we collect, use, and protect your personal information when you visit or use our website.",
            "keywords": "Privacy Policy, Vêtir Data Collection, User Privacy, Data Protection, Online Privacy"
        },
        "terms-and-conditions": {
            "title": "Vêtir (Terms & Conditions) | Vêtir | Luxury Shopping & Technology Meet",
            "description": "Explore the terms and conditions governing your use of Vêtir, where luxury shopping meets cutting-edge technology.",
            "keywords": "Terms & Conditions, Vêtir Legal, User Agreement, Luxury Shopping Terms, Technology Shopping Conditions"
        },
        "contact-us": {
            "title": "Contact Us | Vêtir",
            "description": "Reach out to Vêtir for inquiries, support, or feedback. We are here to assist you.",
            "keywords": "Contact Us, Customer Support, Help Desk, Vêtir Assistance, Inquiry"
        },
        "about": {
            "title": "About Us | Vêtir is where luxury shopping and technology meet | Vêtir",
            "description": "Vêtir is where luxury shopping and technology meet. A revolutionary AI-powered smart shopping, digital styling and closet management platform, we bring a highly personalizedexperience with limitless possibilities. The future of shopping is now—let us empower your style.",
            "keywords": "Vêtir is where luxury shopping and technology meet. A revolutionary AI-powered smart shopping, digital styling and closet management platform, we bring a highly personalizedexperience with limitless possibilities. The future of shopping is now—let us empower your style."
        },
        "returns-and-exchanges": {
            "title": "Returns & Exchanges |  | Vêtir",
            "description": "Vêtir partners with a diverse range of luxury retailers and brands to offer you an extensive selection of products. As such, return and exchange policies may vary depending on the brand or retailer from which your order was shipped. Please refer to the product page for each brand or retailer partners’ individual return policies.",
            "keywords": "Returns & Exchanges, Luxury Shopping, Technology in Fashion, AI-Powered Shopping, Digital Styling, Closet Management, Personalized Shopping Experience, Future of Shopping, Style Empowerment"
        },
        "addresslist": {
            "title": "Address List | Vêtir | Luxury Shopping & Technology Meet",
            "description": "Manage your shipping addresses with ease. Add, edit, or delete your addresses to ensure smooth and efficient delivery.",
            "keywords": "Address List, Shipping Addresses, Delivery Addresses, Address Management, Luxury Shopping, Technology Integration, Shopping Experience"
        },
        "product": {
            "title": " Vêtir | Luxury Shopping & Technology Meet",
            "description": "Explore the latest fashion products from the world's leading brands.",
            "keywords": "Product, Luxury Shopping, Technology Integration, Fashion Insights, Shopping Experience"
        },
        "add-address": {
            "title": "Add New Address | Vêtir",
            "description": "Add New Address",
            "keywords": "Add New Address, Shipping Addresses, Delivery Addresses, Address Management, Luxury Shopping, Technology Integration, Shopping Experience"
        },

        "profile": {
            "title": "My Account | Vêtir",
            "description": "Manage your account information, preferences, and settings.",
            "keywords": "My Account, Account Management, User Preferences, Settings, Luxury Shopping, Technology Integration, Shopping Experience"
        },

        "editProfile": {
            "title": "My Profile | Vêtir",
            "description": "Manage your profile information, preferences, and settings.",
            "keywords": "My Profile, Profile Management, User Preferences, Settings, Luxury Shopping, Technology Integration, Shopping Experience"
        },

        "checkout": {
            "title": "Shopping Bag | Vêtir",
            "description": "Manage your shopping bag, add or remove items, and checkout securely.",
            "keywords": "Shopping Bag, Shopping Cart, Checkout, Luxury Shopping, Technology Integration, Shopping Experience"
        },
        "order-details": {
            "title": "Order History Details | Vêtir",
            "description": "Explore your order history, track your orders, and manage your shipping details.",
            "keywords": "Order History Details, Order Tracking, Shipping Details, Luxury Shopping, Technology Integration, Shopping Experience"
        }
    }
}
